// Small shared formatting helpers.

// Accepts either an epoch-millisecond number (the contract's wire format) or an
// ISO string — `new Date(...)` handles both.
export function formatDate(at?: number | string | null): string {
  if (at == null) return "—";
  const d = new Date(at);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });
}

export function formatRelative(at?: number | string | null): string {
  if (at == null) return "never";
  const d = new Date(at).getTime();
  if (Number.isNaN(d)) return "never";
  const diff = Date.now() - d;
  const mins = Math.round(diff / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  return `${days}d ago`;
}

// Free-tier usage resets at the first instant of next calendar month (UTC) —
// matches the API's `startOfMonth` window. Returns a friendly date label.
export function monthlyResetDate(): Date {
  const n = new Date();
  return new Date(Date.UTC(n.getUTCFullYear(), n.getUTCMonth() + 1, 1));
}

export function monthlyResetLabel(): string {
  return monthlyResetDate().toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
  });
}

export function formatBytes(bytes?: number | null): string {
  if (bytes == null) return "—";
  if (bytes === 0) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(value < 10 && i > 0 ? 1 : 0)} ${units[i]}`;
}
